"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Quote, CircleCheck, ArrowRight, ArrowLeft } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Dr. Aris T.",
  quote: "Family First Senior Care sets the gold standard for a small assisted living home with personalized care in Silver Spring, caring for up to five residents with personalized, family‑like attention.",
  position: "Local Physician",
  badge: "Community Partner",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/avatar_partner.png"
}];
export default function VoicesOfHowardCounty() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="27260" id="words-from-families" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {}
          <div className="mb-16 md:mb-24 max-w-2xl">
            <h2 className="text-primary font-serif text-4xl md:text-5xl lg:text-6xl leading-tight mb-6">
              A Warm & Boutique Assisted Living in Silver Spring, Maryland
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl font-sans max-w-lg leading-relaxed">
              Experience residential assisted living in Montgomery County at Family First Senior Care in Silver Spring, Maryland. Our small assisted living home with personalized care serves just five residents, providing the dedicated care and family-like atmosphere your loved ones deserve.
            </p>
          </div>

          {}
          
        </div>
      </div>
    </section>;
}